<template>
  <div class="w-full md:w-11/12 mx-auto my-6">
      <div class="flex flex-col py-6 px-14 md:px-20 font-costea">
        <p class="text-t12 text-costeaGray flex flex-row justify-center items-center self-end">Fecha de versión: <span class="ml-2">{{termsConditions.header.dateReview}}</span></p>
        <div class="w-full mb-6">
            <h4 class="text-costeaDarkGray text-t18">{{termsConditions.header.preTitle}}</h4>
            <h1 class="text-costeaBlack text-h24 font-medium">{{termsConditions.header.title}}</h1>
            <p class="mt-4 font-costea text-costeaDarkGray leading-7 text-t16 text-justify">{{termsConditions.header.description}}</p>
        </div>
      </div>

      <div class="bg-white w-full grid grid-cols-12 font-costea px-6 md:px-20 py-12">
        <div class="col-span-full md:col-span-3">
          <div class="h-full flex flex-col">
            <h3 class="flex text-t16 font-medium pb-4 text-black">Contenido</h3>
            <ul class="text-t16 ml-2 text-costeaDarkGray">
              <li 
                v-for="termCondition in termsConditions.content"
                :key="termCondition.index" 
                class="flex py-1">
                <a
                  :href="['#'+termCondition.title]"
                  @click="selected = termCondition.title"
                  :class="['cursor-pointer hover:text-costeaPrimary', {'text-costeaPrimary': selected==termCondition.title}]">
                  {{termCondition.title}}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-span-9 font-costea text-costeaDarkGray leading-7 text-t16">
          <div 
            v-for="termCondition in termsConditions.content"
            :key="termCondition.index"
            class="mt-10 md:my-6 border-b-2 pb-4 cursor-pointer">
            <h3 
              @click="selected = termCondition.title"
              :id="termCondition.title"
              :class="['flex items-center font-medium text-black', {'text-costeaPrimary': selected == termCondition.title}]">
              <i 
                :class="['ri-add-fill mr-4 text-costeaPrimary', {'ri-arrow-up-s-line': selected == termCondition.title}]">
              </i> 
              {{termCondition.title}}
            </h3>
            <p v-show="selected == termCondition.title" class="ml-8">{{termCondition.description}}</p>
          </div>
        </div>
      </div>
      
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    name: "Condiciones",
    data(){
        return{
          selected: "Definiciones"
        }
    },
    computed:{
      ...mapState(['termsConditions']),
    }
}
</script>

<style>

</style>